{
  "/features/domain-verification": "/feature/domain-verification",
  "/features/email-webhooks": "/feature/email-webhooks",
  "/features/inbound-email": "/feature/inbound-email",
  "/features": "/feature",
  "/features/transactional-email-api": "/feature/transactional-email-api",
  "/for/ai-agents": "/audience/ai-agents",
  "/for/developers": "/audience/developers",
  "/for/founders": "/audience/founders",
  "/for": "/audience"
}
